import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconViewBoard = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.5 4.5V7.5H7.5V4.5H4.5ZM3 4.5C3 3.67188 3.67188 3 4.5 3H7.5C8.32812 3 9 3.67188 9 4.5V7.5C9 8.32812 8.32812 9 7.5 9H4.5C3.67188 9 3 8.32812 3 7.5V4.5ZM4.5 12.5V15.5H7.5V12.5H4.5ZM3 12.5C3 11.6719 3.67188 11 4.5 11H7.5C8.32812 11 9 11.6719 9 12.5V15.5C9 16.3281 8.32812 17 7.5 17H4.5C3.67188 17 3 16.3281 3 15.5V12.5ZM15.5 4.5H12.5V7.5H15.5V4.5ZM12.5 3H15.5C16.3281 3 17 3.67188 17 4.5V7.5C17 8.32812 16.3281 9 15.5 9H12.5C11.6719 9 11 8.32812 11 7.5V4.5C11 3.67188 11.6719 3 12.5 3ZM12.5 12.5V15.5H15.5V12.5H12.5ZM11 12.5C11 11.6719 11.6719 11 12.5 11H15.5C16.3281 11 17 11.6719 17 12.5V15.5C17 16.3281 16.3281 17 15.5 17H12.5C11.6719 17 11 16.3281 11 15.5V12.5Z",
		fill: "currentColor"
	})
});
export default SvgIconViewBoard;
